import { DoorSlidingIcon } from './DoorSlidingIcon';

/**
 * author: Google
 * id 73FBEFFD-7EE3-4272-AB1F-A480C698FD5E
 * name door-sliding
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/door-sliding.svg
 * tags
 * - Home Automation 
 */
export const PatioDoorIcon = DoorSlidingIcon;
export default PatioDoorIcon